import React from 'react';
import {useDispatch} from 'react-redux';
import {Form, Select} from 'semantic-ui-react';
import {parseChassisValues} from '../../utils';
import {Actions} from '../../../common/actions';

const {fetchChassisListBySearchParam} = Actions;

const SearchForm = ({
  chassisList,
  handleChange,
  loadingChassisList,
  chassis,
}) => {
  const dispatch = useDispatch();

  const handleSearchChassis = (e, {searchQuery}) => {
    if (searchQuery.length >= 4) {
      const search = searchQuery;
      dispatch(fetchChassisListBySearchParam({search}));
    }
    handleChange('chassis', searchQuery);
  };
  
  return (
    <React.Fragment>
      <Form.Field
        search
        label='Chasis'
        name='chassis'
        placeholder='Chasis'
        control={Select}
        options={parseChassisValues(chassisList)}
        value={chassis}
        loading={loadingChassisList}
        disabled={loadingChassisList}
        onChange={(e, {value}) => handleChange('chassis', value)}
        onSearchChange={handleSearchChassis}
        noResultsMessage='No se encontro resultados'
      />
    </React.Fragment>
  );
};

export default SearchForm;
